// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"Loading_backdrop__3fje-","text":"Loading_text__2ExOL"};